"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _cmsDesignComponent = require("@tencent/cms-design-component");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const formatFreeWithCard = (properties, options = {}) => {
  const modTitle = properties.modTitle,
    color = properties.color,
    txt = properties.txt,
    hrefBase = properties.href,
    commodityObject = properties.commodityObject,
    isLink = properties.isLink,
    mainNum1 = properties.mainNum1,
    description1 = properties.description1,
    mainNum2 = properties.mainNum2,
    description2 = properties.description2,
    mainNum3 = properties.mainNum3,
    description3 = properties.description3,
    mergeComponentStatus = properties.mergeComponentStatus,
    paddingTopNum = properties.paddingTopNum,
    paddingBottomNum = properties.paddingBottomNum;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  const href = formatUrlString(hrefBase);
  const configuration = [];
  mainNum1 && configuration.push({
    mainNum: mainNum1,
    description: description1
  });
  mainNum2 && configuration.push({
    mainNum: mainNum2,
    description: description2
  });
  mainNum3 && configuration.push({
    mainNum: mainNum3,
    description: description3
  });
  const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
  configuration.push(_objectSpread(_objectSpread({
    txt,
    href,
    isLink
  }, resultCommodityObject), {}, {
    extendProps: {
      'report-event-goal': 'click_offer',
      'report-event': 'click_free_with_card_button',
      'report-ext1': txt,
      'report-ext2': href
    }
  }));
  return {
    modTitle,
    configuration,
    bgColor: color,
    mergeComponentStatus,
    paddingTopNum,
    paddingBottomNum
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatFreeWithCard = formatFreeWithCard(data, {
        domains
      }),
      modTitle = _formatFreeWithCard.modTitle,
      configuration = _formatFreeWithCard.configuration,
      bgColor = _formatFreeWithCard.bgColor,
      mergeComponentStatus = _formatFreeWithCard.mergeComponentStatus,
      paddingTopNum = _formatFreeWithCard.paddingTopNum,
      paddingBottomNum = _formatFreeWithCard.paddingBottomNum;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_freeWithCardNew', componentKey, modTitle])), /*#__PURE__*/React.createElement(_cmsDesignComponent.FreeWithCard, {
      flexTitle: modTitle,
      mergeComponentStatus: mergeComponentStatus,
      paddingTopNum: paddingTopNum,
      paddingBottomNum: paddingBottomNum,
      configuration: configuration,
      style: bgStyle,
      onCallback: () => {
        // asyncReceiveCommodity(configuration[configuration.length - 1]);
        window.asyncReceiveCommodity(configuration[configuration.length - 1]);
        // console.log(configuration, 'configuration-FreeWithCard');
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}